var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { Paper, ActionIcon, Box, Flex, } from '@mantine/core';
import { CSS } from '@dnd-kit/utilities';
import { DotsSixVerticalIcon, XIcon, } from '@phosphor-icons/react';
import { useNavigate } from "react-router";
import WordCardEditView from "./WordCardEditView";
import WordCardContentView from "./WordCardContentView";
export default function WordCard(_a) {
    var card = _a.card, editingCardId = _a.editingCardId, onRemove = _a.onRemove, onStartEdit = _a.onStartEdit, onSaveEdit = _a.onSaveEdit, onCancelEdit = _a.onCancelEdit;
    var navigate = useNavigate();
    var editing = editingCardId === card.uuid ? 'this' : (editingCardId === null ? 'none' : 'other');
    var _b = useSortable({ id: card.uuid, disabled: editing !== 'none', }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition, isDragging = _b.isDragging;
    var style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        zIndex: isDragging ? 10 : 1,
        opacity: isDragging ? 0.6 : (editing === 'other' ? 0.6 : 1),
        backgroundColor: 'white',
        minHeight: 160,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };
    return _jsxs(Paper, { ref: setNodeRef, style: style, withBorder: true, shadow: isDragging ? 'md' : 'sm', p: "md", radius: "md", children: [_jsxs(Flex, { justify: "space-between", align: "center", children: [_jsx(Box, __assign({}, (editing === 'none' ? attributes : {}), (editing === 'none' ? listeners : {}), { style: {
                            cursor: editing !== 'none' ? 'not-allowed' : 'grab',
                            display: 'flex',
                            alignItems: 'center',
                            color: editing !== 'none' ? 'var(--mantine-color-gray-3)' : 'var(--mantine-color-gray-5)',
                            touchAction: 'none',
                        }, children: _jsx(DotsSixVerticalIcon, { size: 20, weight: "bold" }) })), _jsx(ActionIcon, { variant: "subtle", color: "gray", size: "sm", disabled: editing !== 'none', onClick: function () { return onRemove(card); }, "aria-label": "Remove word", children: _jsx(XIcon, { size: 16, weight: "bold" }) })] }), editing === 'this'
                ? _jsx(WordCardEditView, { card: card, onSaveEdit: onSaveEdit, onCancelEdit: onCancelEdit })
                : _jsx(WordCardContentView, { card: card, onStartEdit: onStartEdit, editing: editing })] });
}
